"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const design_system_1 = require("@zapier/design-system");
const react_1 = require("react");
const ContinueButton_1 = __importDefault(require("../ContinueButton"));
const EventPicker_1 = __importDefault(require("../EventPicker"));
const SelectionCard_1 = __importDefault(require("../SelectionCard"));
const helperTextStyles = core_1.css `
  font-size: 12px;
  margin-top: 6px;
`;
const sectionStyles = core_1.css `
  padding-bottom: 20px;
`;
const DEFAULT_PROPS = {
    hasEventPicker: true,
};
function JobCentricAppAndEventPicker(props) {
    const propsWithDefaults = Object.assign(Object.assign({}, DEFAULT_PROPS), props);
    const { appName, banner, eventGroups, hasEventPicker, isBusy, isTrigger, onChangeEvent, onChangeApp, onContinue, selectedEvent, selectedApi, } = propsWithDefaults;
    const onChangeEventWrapper = (event, eventLocation) => {
        onChangeEvent(event, eventLocation);
    };
    return (core_1.jsx(react_1.Fragment, null,
        core_1.jsx("section", { css: sectionStyles },
            core_1.jsx(SelectionCard_1.default, { ariaLabel: "Choose an app", banner: banner, hasChangeLink: true, isAppCard: true, onSelect: onChangeApp, selectedApi: selectedApi, selectionName: appName })),
        hasEventPicker && (core_1.jsx("section", { css: sectionStyles },
            core_1.jsx(design_system_1.FormLabel, { isRequired: true, layout: "text-only" },
                isTrigger ? 'Trigger' : 'Action',
                " Event"),
            core_1.jsx(design_system_1.Spacer, { height: 8 }),
            core_1.jsx(EventPicker_1.default, { groups: eventGroups, initialValue: selectedEvent, onSelect: onChangeEventWrapper }),
            isTrigger ? (core_1.jsx("p", { css: helperTextStyles }, "This is what starts the Zap.")) : (core_1.jsx("p", { css: helperTextStyles }, "This is performed when the Zap runs.")))),
        core_1.jsx(ContinueButton_1.default, { canContinue: Boolean(selectedApi && selectedEvent), disabledText: "To continue, choose an event", isBusy: isBusy, onContinue: onContinue })));
}
exports.default = JobCentricAppAndEventPicker;
